export const PERSONS_END_USERS_TABLE_CHANGE = 'PERSONS_END_USERS_TABLE_CHANGE'
export const PERSONS_END_USERS_TABLE_DATA_RECEIVED = 'PERSONS_END_USERS_TABLE_DATA_RECEIVED'
export const PERSONS_END_USERS_TABLE_LOADING_TRUE = 'PERSONS_END_USERS_TABLE_LOADING_TRUE'
export const PERSONS_END_USERS_TABLE_LOADING_FALSE = 'PERSONS_END_USERS_TABLE_LOADING_FALSE'

export const PERSONS_END_USERS_TABLE_CHANGE_REQUEST = (id) => `PERSONS_END_USERS_${id}_TABLE_CHANGE_REQUEST`
